import React, { useEffect } from "react";
import {
	Grid,
	Box,
	Typography,
	Paper,
	Chip,
	Alert,
	Button,
	CircularProgress
} from '@mui/material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faDownload, faCheckDouble, faClock, faPen, faArrowLeft, faExclamationTriangle, faCheckCircle, faBan } from "@fortawesome/free-solid-svg-icons";
import { useLang } from '../../language';
import { OtecServices } from '../../controllers/services/otec.services'

export const DetalleSolicitud = ({
	datosCliente,
	solicitudState,
	setSolicitudState,
	fetchDatosPersonales
}:any) => {

	const Lang = useLang()

	const { fetchData: fetchBajaSolicitud, data: datosBajaSolicitud, loading: loadingBajaSolicitud} = OtecServices.POST_BAJA_SOLICITUD();

	const handleDescargar = () => {
	    if (datosCliente?.pdf) {
	      window.open(datosCliente?.pdf?.url_pdf, "_blank");
	    } else {
	      alert("No se encontró la URL del PDF.");
	    }
	};

	const handleEditarInformacion = () => {
		setSolicitudState('pendiente_firma');
	}

	const handleBajaSolictud = (e:any) => {
	    e.preventDefault();
	    fetchBajaSolicitud({
            body: {
              accion: 'baja_solicitud',
              solicitud_id: datosCliente?.id,
            }  
        });
	};

	useEffect(() => {
		if(datosBajaSolicitud?.success){
			fetchDatosPersonales({
				body: {
					accion: 'obtener_datos'
				}
			})
		}
	},[datosBajaSolicitud])

	return (
		<Grid container spacing={3} justifyContent="center" >
			<Grid item xs={12} lg={12} xl={11} className='mb-4 pb-2 xxl-8'>
				<Paper className='p-3 p-md-4'>
					<Typography variant='h6' className="my-0 pb-2 fw-500 color-primary text-center">
						{Lang('DETALLE_SOLICITUD_OTED_TITULO')}
					</Typography>
					<Box component="form" sx={{ mt: 3 }}>
				          {solicitudState === "activo" ? (
							  <Alert
							    icon={<FontAwesomeIcon icon={faCheckDouble} />}
							    severity="success"
							    sx={{ alignItems: "center", flexDirection: "column", textAlign: "center" }}
							  >
							    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
							      <Typography variant="body1" sx={{ fontWeight: "medium", mr: 1 }}>
							        Document signat digitalment
							      </Typography>
							      <Chip
							        label="Vàlid i verificat"
							        size="small"
							        color="success"
							        variant="outlined"
							        sx={{ ml: 1 }}
							      />
							    </Box>
							    <Typography variant="body2" sx={{ mt: 0.5 }}>
							      Signatura realitzada el {datosCliente?.pdf?.fecha_firma}
							    </Typography>

							    <Box sx={{ mt: 2, textAlign: "center" }}>
							      <Button 
							        variant="outlined" 
							        color="error" 
							        size="small"
							        startIcon={loadingBajaSolicitud ? <CircularProgress size={20} thickness={4} color="inherit" /> : <FontAwesomeIcon icon={faBan} />}
							        onClick={handleBajaSolictud}
							        disabled={loadingBajaSolicitud}
							      >
							        Donar de baixa contracte
							      </Button>
							    </Box>
							  </Alert>
							) : solicitudState === "baja" ? (
							  <Alert
							    icon={<FontAwesomeIcon icon={faBan} />}
							    severity="error"
							    sx={{ alignItems: "center" }}
							  >
							    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
							      <Typography variant="body1" sx={{ fontWeight: "medium", mr: 1 }}>
							        Contracte donat de baixa
							      </Typography>
							      <Chip
							        label="Baixa"
							        size="small"
							        color="error"
							        variant="outlined"
							        sx={{ ml: 1 }}
							      />
							    </Box>
							    <Typography variant="body2" sx={{ mt: 0.5 }}>
							      Aquesta sol·licitud ha estat donada de baixa per l’administrador.
							    </Typography>
							  </Alert>
							) : (
							  <Alert
							    icon={<FontAwesomeIcon icon={faClock} />}
							    severity="info"
							    sx={{ alignItems: "center" }}
							  >
							    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
							      <Typography variant="body1" sx={{ fontWeight: "medium", mr: 1 }}>
							        Document pendent de verificació
							      </Typography>
							      <Chip
							        label="En revisión"
							        size="small"
							        color="info"
							        variant="outlined"
							        sx={{ ml: 1 }}
							      />
							    </Box>
							    <Typography variant="body2" sx={{ mt: 0.5 }}>
							      L'administrador verificarà el document i rebrà una notificació al correu registrat quan estigui aprovat. Un cop aprovat, si editeu les dades, no caldrà sol·licitar una nova verificació.
							    </Typography>
							  </Alert>
							)}

					</Box>

					<Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
				      <Button
				        variant="contained"
				        color="primary"
				        startIcon={<FontAwesomeIcon icon={faDownload} />}
				        onClick={handleDescargar}
				      >
				        Descarregar PDF
				      </Button>
				      <Button
				        variant="outlined"
				        startIcon={<FontAwesomeIcon icon={faPen} />}
				        color="secondary"
				        onClick={handleEditarInformacion}
				      >
				        Edita Dades
				      </Button>
				    </Box>

				    {datosCliente?.observaciones_admin && (
					  <Box
					    sx={{
					      mt: 3,
					      p: 2,
					      borderRadius: 2,
					      border: "1px solid",
					      borderColor: "grey.300",
					      bgcolor: "grey.50",
					      maxWidth: 600,
					      mx: "auto",
					    }}
					  >
					    <Typography
					      variant="subtitle2"
					      sx={{ fontWeight: "bold", mb: 1, color: "text.secondary" }}
					    >
					      Observació de l'administrador
					    </Typography>
					    <Typography variant="body2" sx={{ color: "text.primary" }}>
					      {datosCliente?.observaciones_admin}
					    </Typography>
					  </Box>
					)}

				    <Typography
				      variant="body2"
				      color="error"
				      align="center"
				      sx={{ mt: 2, fontWeight: "medium" }}
				    >
				      Si editeu la informació, el document passarà novament a estat
				      pendent de signatura.
				    </Typography>

				 </Paper>	
			</Grid>
		</Grid>		 
	)
}